/**
 * ATC Price Display
 * Shows the price on Add to Cart buttons, matching the bundle pricing button style.
 * Listens for variant changes and updates the displayed price accordingly.
 * Skips bundle products (bundle-pricing.js handles those).
 */
(function () {
  'use strict';

  if (window.__atcPriceDisplayInitialized) return;
  window.__atcPriceDisplayInitialized = true;

  function isBundlePage() {
    return !!document.querySelector('.bundle-pricing-container');
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function buildPriceHTML(label, price, compareAtPrice) {
    if (compareAtPrice && compareAtPrice > price) {
      return '<span class="atc-price__label">' + label + ' - </span>' +
        '<span class="atc-price__compare">' + formatMoney(compareAtPrice) + '</span>' +
        '<span class="atc-price__current">' + formatMoney(price) + '</span>' +
        '<span class="atc-price__arrow" aria-hidden="true">\u2192</span>';
    }
    return '<span class="atc-price__label">' + label + ' - ' + formatMoney(price) + '</span>' +
      '<span class="atc-price__arrow" aria-hidden="true">\u2192</span>';
  }

  function init() {
    if (isBundlePage()) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (data) {
      if (isBundlePage()) return;

      var variant = data && data.variant;
      if (!variant) return;

      var buttons = document.querySelectorAll('product-form button[name="add"]');

      buttons.forEach(function (button) {
        if (button.closest('cart-drawer')) return;
        var atcSpan = button.querySelector('[data-atc-text]');
        if (!atcSpan) return;

        if (variant.available) {
          var label = button.dataset.atcLabel || 'Add to cart';
          atcSpan.innerHTML = buildPriceHTML(label, variant.price, variant.compare_at_price);
        } else {
          atcSpan.textContent = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
